import { createSelector } from 'selectors'
import { constant } from './constant'

export const getPdfExportSelector: (scope?: HTMLElement) => NodeListOf<HTMLElement> | null = (scope?: HTMLElement) =>
	createSelector({ scope, selector: constant.selector.pdfLinkExport }, true)
